import { useState, useEffect } from "react";
import {
  getConfig,
  updateConfig,
} from "../../api/settings";
import "./style.css"
import { Input, Select, message, List, Slider  } from "antd";
const { Option } = Select;

const OpenAIConfig = () => {
  const [formState, setFormState] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  const getConfigData = async () => {
    try {
      const response = await getConfig();
      if (response) {
        setFormState((prevState) => ({
          ...prevState,
          openaikey: response.openaikey,
          temperature: response.temperature,
          model: response.model,
          openaiMaxToken: response.openaiMaxToken,
          openaiTopP :response.openaiTopP,
          openaiFrequency: response.openaiFrequency,
          openaiPresence :response.openaiPresence
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getConfigData();
  }, []);

  const handleUpdateClick = async () => {
    setIsEditing(!isEditing);
    if (isEditing) {
      const response = await updateConfig(formState);
      if (response) {
        message.success(response.message);
      } else {
        message.error(response.message);
      }
    }
  };

  const renderSecretKey = () => {
    if (formState?.openaikey?.length > 3) {
      const firstThree = formState?.openaikey?.slice(0, 3);
      const lastThree = formState?.openaikey?.slice(-3);
      const middlePart = formState?.openaikey?.slice(3, -3).replace(/./g, "*");
      return firstThree + middlePart + lastThree;
    } else {
      return formState?.openaikey;
    }
  };

  const data = [
    { title: "OpenAI API key", description: formState?.openaikey || "" },
    {
      title: "Temperature (between 0 and 2)",
      description: formState.temperature || "",
    },
    { title: "Model", description: formState?.model || "" },
    { title: "Max Token (up to 4096 tokens)", description: formState?.openaiMaxToken || "" },
    { title: "Top P (between 0 and 1)", description: formState?.openaiTopP || "" },
    { title: "Frequency Penalty (between 0 and 2)", description: formState?.openaiFrequency || "" },
    { title: "Presence Penalty (between 0 and 2)", description: formState?.openaiPresence || "" },
  ];

  return (
    <>
      {/* <div className="scrollable-list"> */}
      <div className="">
      <List
        header={<div>Change Settings</div>}
        size="small"
        bordered
        dataSource={data}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              title={item.title}
              description={
                item.title === "OpenAI API key" ? (
                  isEditing ? (
                    <Input
                      type="password"
                      value={item.description}
                      onChange={(e) =>
                        setFormState({
                          ...formState,
                          openaikey: e.target.value,
                        })
                      }
                    />
                  ) : (
                    renderSecretKey()
                  )
                ) : item.title === "Temperature (between 0 and 2)" ? (
                  <Slider
                    min={0}
                    max={2}
                    step={0.1}
                    value={formState.temperature || 0}
                    onChange={(value) =>
                      setFormState({
                        ...formState,
                        temperature: value,
                      })
                    }
                    disabled={!isEditing}
                    style={{ width: '300px' }}
                  />
                ) : item.title === "Model" ? (
                  <Select
                    className="editConfigSelectField"
                    name="model"
                    value={formState?.model || ""}
                    onChange={(e) =>
                      setFormState({
                        ...formState,
                        model: e,
                      })
                    }
                  >
                    <Option value="gpt-3.5-turbo">GPT-3.5 Turbo</Option>
                    <Option value="gpt-4">GPT-4</Option>
                    <Option value="gpt-4o">GPT-4o</Option>
                    <Option value="gpt-4o-mini">GPT-4o-mini</Option>
                    <Option value="o1-preview">o1-preview</Option>
                    <Option value="o1-mini">o1-mini</Option>
                  </Select>
                ) : item.title === "Top P (between 0 and 1)" ? (
                  <Slider
                    min={0}
                    max={1}
                    step={0.1}
                    value={formState.openaiTopP || 0}
                    onChange={(value) =>
                      setFormState({
                        ...formState,
                        openaiTopP: value,
                      })
                    }
                    disabled={!isEditing}
                    style={{ width: '300px' }}
                  />
                ) : item.title === "Frequency Penalty (between 0 and 2)" ? (
                  <Slider
                    min={0}
                    max={2}
                    step={0.1}
                    value={formState.openaiFrequency || 0}
                    onChange={(value) =>
                      setFormState({
                        ...formState,
                        openaiFrequency: value,
                      })
                    }
                    disabled={!isEditing}
                    style={{ width: '300px' }}
                  />
                ) : item.title === "Presence Penalty (between 0 and 2)" ? (
                  <Slider
                    min={0}
                    max={2}
                    step={0.1}
                    value={formState.openaiPresence || 0}
                    onChange={(value) =>
                      setFormState({
                        ...formState,
                        openaiPresence: value,
                      })
                    }
                    disabled={!isEditing}
                    style={{ width: '300px' }}
                  />
                ) : item.title === "Max Token (up to 4096 tokens)" ? (
                  <Slider
                    min={0}
                    max={4096}
                    step={10}
                    value={formState.openaiMaxToken || 0}
                    onChange={(value) =>
                      setFormState({
                        ...formState,
                        openaiMaxToken: value,
                      })
                    }
                    disabled={!isEditing}
                    style={{ width: '300px' }}
                  />
                ) : (
                  item.description
                )
              }
            />
          </List.Item>
        )}
      />
        <div className="text-end">
          <a
            onClick={handleUpdateClick}
            key="list-loadmore-edit"
            className="btn btn-outline-dark"
          >
            {isEditing ? "Update" : "Edit"}
          </a>
          {isEditing && (
            <a
              onClick={() => setIsEditing(!isEditing)}
              key="list-loadmore-cancel"
              className="btn btn-outline-dark"
            >
              Cancel
            </a>
          )}
        </div>
      </div>
    </>
  );
};

export default OpenAIConfig;
